import React, { useEffect, useState } from "react";
import { fetchDataFromAPI } from "../components/api"; // Import the fetch utility
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "../context/ThemeContext";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import subscriptionStatus from "../components/SubscriptionStatus";
const Invoice = ({ orderId, onClose }) => {
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();

  const { theme } = useTheme();
  const buttonColor = isSubscribed
    ? theme.button
    : process.env.REACT_APP_BUTTON;
  const textColor = isSubscribed ? theme.text : process.env.REACT_APP_TEXT;
  console.log("buttonColor", buttonColor);
  console.log("textColor", textColor);
  console.log("theme.text", theme.text);
  console.log("theme.button", theme.button);

  console.log("process.env.REACT_APP_TEXT", process.env.REACT_APP_TEXT);

  console.log("isSubscribed", isSubscribed);

  useEffect(() => {
    if (orderId) {
      fetchInvoiceData();
    }
  }, [orderId]);

  const fetchInvoiceData = async () => {
    try {
      const token = localStorage.getItem("token"); // Retrieve auth token
      if (!token) throw new Error("Unauthorized: No token found.");

      // Fetch invoice data
      const { invoice } = await fetchDataFromAPI(
        `/api/invoice/${orderId}`,
        {},
        token
      );
      setInvoiceData(invoice);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const sendToWhatsApp = (invoiceData) => {
    // Message content
    const message = `Hello ${invoiceData.customerName}, here is your invoice:
  Invoice No: #${invoiceData.publicId}
  Date: ${new Date(invoiceData.orderDate).toLocaleDateString()}
  Total: $${invoiceData.total_amount}
  View full invoice: ${window.location.origin}/invoice/${invoiceData.publicId}`;

    // Encode for URL
    const encodedMsg = encodeURIComponent(message);

    // WhatsApp API link (no number → user chooses contact)
    const url = `https://wa.me/?text=${encodedMsg}`;

    // Open WhatsApp Web / Mobile app
    window.open(url, "_blank");
  };

  if (loading) return <p className="text-center text-lg">Loading invoice...</p>;
  if (error) return <p className="text-center text-red-500">Error: {error}</p>;
  if (!invoiceData)
    return <p className="text-center text-gray-500">No invoice found</p>;

  return (
    <Dialog open={Boolean(orderId)} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}
      >
        Invoice
        {/* <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "gray" }}
        >
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <div className="flex justify-center">
            <CircularProgress />
          </div>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : invoiceData ? (
          <Paper
            sx={{ padding: 3, border: "1px solid #ccc", borderRadius: "8px" }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* Add company logo */}
                <img
                  src={invoiceData.companyLogo}
                  alt={`${invoiceData.companyName} Logo`}
                  style={{
                    width: "100px", // Adjust the width as necessary
                    height: "auto",
                    marginRight: "10px",
                  }}
                />
                <div>
                  <Typography variant="h6" fontWeight="bold">
                    {invoiceData.companyName}
                  </Typography>
                  <Typography>{invoiceData.companyDescription}</Typography>
                  <Typography>{invoiceData.companyWebsite}</Typography>
                  <Typography>Phone: {invoiceData.companyPhone}</Typography>
                </div>
              </div>

              <div style={{ textAlign: "right" }}>
                <Typography variant="h6" fontWeight="bold">
                  Invoice
                </Typography>
                <Typography>
                  <strong>Invoice No:</strong> #{invoiceData.publicId}
                </Typography>
                <Typography>
                  <strong>Date:</strong>{" "}
                  {new Date(invoiceData.orderDate).toLocaleDateString()}
                </Typography>
                <Typography>
                  <strong>Status:</strong> {invoiceData.status}
                </Typography>
              </div>
            </div>

            <Divider sx={{ my: 2, borderColor: "#ccc" }} />

            {/* Customer Details */}
            <div style={{ marginBottom: "20px" }}>
              <Typography variant="h6" fontWeight="bold">
                Bill To:
              </Typography>
              <Typography>{invoiceData.customerName}</Typography>
              <Typography>{invoiceData.billingAddress}</Typography>
              <Typography>Email: {invoiceData.customerEmail}</Typography>
              <Typography>Phone: {invoiceData.customerPhone}</Typography>
            </div>

            <Divider sx={{ my: 2, borderColor: "#ccc" }} />

            {/* Products Table */}
            <TableContainer component={Paper} sx={{ border: "1px solid #ccc" }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: "bold" }}>Item</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Quantity</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Unit Price
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoiceData.products && invoiceData.products.length > 0 ? (
                    invoiceData.products.map((product, index) => (
                      <TableRow key={index}>
                        <TableCell>{product.productName}</TableCell>
                        <TableCell>{product.quantity}</TableCell>
                        <TableCell>${product.unitPrice}</TableCell>
                        <TableCell>${product.total}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                        No products available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Divider sx={{ my: 2, borderColor: "#ccc" }} />

            {/* Total Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              {/* <div>
                <Typography variant="h6" fontWeight="bold">
                  Payment Methods:
                </Typography>
                <Typography>💳 Credit/Debit Card</Typography>
                <Typography>💰 Bank Transfer</Typography>
              </div> */}
              <div style={{ textAlign: "right" }}>
                <Typography variant="h6" fontWeight="bold">
                  Total Amount:
                </Typography>
                <Typography variant="h5" color="primary">
                  ${invoiceData.total_amount}
                </Typography>
              </div>
            </div>
          </Paper>
        ) : (
          <Typography>No invoice found</Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
        <Button
          onClick={onClose}
          sx={{
            bgcolor: buttonColor,
            color: textColor,
            "&:hover": { backgroundColor: "#115293" },
          }}
        >
          Close
        </Button>
        <Button
          onClick={() => window.print()}
          sx={{
            bgcolor: buttonColor,
            color: textColor,
            "&:hover": { backgroundColor: "#115293" },
          }}
        >
          Print Invoice
        </Button>
        <Button
          onClick={() => sendToWhatsApp(invoiceData)}
          startIcon={<WhatsAppIcon />}
          sx={{
            bgcolor: "#25D366", // WhatsApp green
            color: "#fff", // white text
            fontWeight: "bold",
            textTransform: "none", // keep normal case (not uppercase)
            borderRadius: "8px",
            px: 3, // padding X
            py: 1, // padding Y
            fontSize: "16px",
            "&:hover": {
              backgroundColor: "#128C7E", // darker WhatsApp green
            },
          }}
        >
          Send to WhatsApp
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Invoice;
